/**
 * Tiny external store for tracking whether plugins have been initialized.
 * The PluginsProvider calls `setPluginsReady()` after init.
 * Consumers use `usePluginsReady()` to reactively wait for it.
 */

import { useSyncExternalStore } from 'react';

let ready = false;
const listeners = new Set<() => void>();

export function setPluginsReady(): void {
  ready = true;
  for (const listener of listeners) {
    listener();
  }
}

function subscribe(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => listeners.delete(onStoreChange);
}

function getSnapshot(): boolean {
  return ready;
}

function getServerSnapshot(): boolean {
  return false;
}

export function usePluginsReady(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
